import React, { useState } from "react";
import SearchForm from "./SearchForm";

const SearchBlock = ({ tab_name, arrival_flight_icon, departure_icon }) => {
  const isTransit = tab_name?.toLowerCase().includes("transit");
  const [activeTab, setActiveTab] = useState("departure");

  return (
    <div className="w-full flex flex-col gap-[2vw] xl:gap-[1.2vw]  px-[3vw] xl:px-[1vw] py-[5vw] xl:py-[1vw]">
      {/* Top section shown only for transit */}
      <div
        className={`${
          isTransit ? "block" : "hidden"
        } flex flex-col gap-[14vw] xl:gap-[3vw] w-full bg-white  overflow-hidden`}
      >
        {/* Tabs */}
        <div className="flex flex-row gap-[3vw] xl:gap-[2vw] w-full">
          <button
            className={`flex items-center justify-center w-1/2 text-[4vw] xl:text-[1.5vw] px-[2vw] xl:px-[1vw] py-[2vw] xl:py-[0vw] font-semibold rounded-[1vw] xl:rounded-[0.5vw] ${
              activeTab === "departure"
                ? "bg-[#002f6c] text-white"
                : "bg-gray-200 text-[#002f6c]"
            }`}
            onClick={() => setActiveTab("departure")}
          >
            <img
              src={departure_icon?.url}
              alt="flight icon"
              className="w-[5vw] h-[5vw] xl:w-[3vw] xl:h-[3vw] mr-2 text-red-500"
              style={{
                filter:
                  activeTab === "departure"
                    ? "brightness(0) invert(1)"
                    : "none",
              }}
            />
            Departure
          </button>
          <button
            className={`flex items-center justify-center w-1/2 text-[4vw] xl:text-[1.5vw] px-[2vw] xl:px-[1vw] py-[2vw] xl:py-[0vw] font-semibold rounded-[1vw] xl:rounded-[0.5vw] border-r border-gray-300 ${
              activeTab === "arrivals"
                ? "bg-[#002f6c] text-white"
                : "bg-gray-200 text-[#002f6c]"
            }`}
            onClick={() => setActiveTab("arrivals")}
          >
            <img
              src={arrival_flight_icon?.url}
              alt="flight icon"
              style={{
                filter:
                  activeTab === "arrivals" ? "brightness(0) invert(1)" : "none",
              }}
              className="w-[5vw] h-[5vw] xl:w-[3vw] xl:h-[3vw] mr-2"
            />
            Arrivals
          </button>
        </div>

        {/* Divider with "By Route" text */}
        <div className="relative border-t border-gray-300">
          <div className="absolute -top-[7.5vw] xl:-top-[2vw] left-4 bg-white text-[4.5vw] xl:text-[1.2vw] font-semibold text-gray-700">
            By Route
            <div className="h-[2px] w-full bg-orange-500 "></div>
          </div>
        </div>
      </div>

      <div>
        <SearchForm tab_name={tab_name} sub_tab_name={activeTab} />
      </div>
    </div>
  );
};

export default SearchBlock;
